import { getUserinfo } from '@shakkerai/business-userinfo';
import { useUserInfo } from '../store';

export const initUserInfo = async (isForced) => {
  const { data: userInfo } = await getUserinfo(isForced);

  if (!userInfo) {
    if (!isForced) {
      useUserInfo.setState({ __initialized: true });
      return { __initialized: true };
    }

    if (!['/pro', '/aigenerator'].includes(window.location.pathname)) {
      window.location.href = '/';
    }

    return;
  }

  useUserInfo.setState({ userInfo, __initialized: true });
  return { userInfo, __initialized: true };
};
